var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmojiUnhappy = function SvgEmojiUnhappy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 11.85c0-.47.448-.85 1-.85h.01c.552 0 1 .38 1 .85s-.448.85-1 .85H11c-.552 0-1-.38-1-.85m6 0c0-.47.448-.85 1-.85h.01c.552 0 1 .38 1 .85s-.448.85-1 .85H17c-.552 0-1-.38-1-.85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.814 18.622a1 1 0 0 0 1.336-.452l.003-.007.026-.046a4.95 4.95 0 0 1 .662-.886c.49-.52 1.201-1.05 2.16-1.231.957-.18 1.813.054 2.458.36a5 5 0 0 1 .94.583l.04.034.006.006a1 1 0 0 0 1.346-1.48l-.675.738c.675-.738.674-.739.674-.739l-.002-.001-.003-.003-.009-.008-.026-.023-.084-.071a6.95 6.95 0 0 0-1.35-.844c-.893-.423-2.188-.8-3.687-.517s-2.567 1.106-3.243 1.824a7 7 0 0 0-.95 1.278l-.054.097-.016.031-.005.01-.002.005v.001l-.002.002a1 1 0 0 0 .457 1.339"
  })));
};
export default SvgEmojiUnhappy;